import { useEffect, useState } from "react";
import app from "../components/app";
import Widget from "../preview" 

export default function Preview(props) {
    console.log(props);
    const [device, setDevice] = useState("desktop");
    useEffect(() => {
        // app.fetchPost({
        //   "method":"get",
        //   "id":props.subcategory
        // }).then(function(response){
        //   console.log(response);
        // });
    }, [])
    let wrapStyle = {height:"calc(100% - 55px)", marginTop:"55px"};
    if(device === "mobile") {
        wrapStyle = {maxWidth:"380px", height:"calc(100% - 55px)", marginTop:"55px"};
    }
    return <div className="w-100 h-100">
         <div className={`wb-header`} style={{top:0}}>
            <div className="wb-col d-flex">
                <a  className="wb-text ps-0" href={`/${props.domain}`}><i className="icon-left-open"></i> Back</a>
            </div>
            <div className="wb-col view-ui">
      {
        [
          {key:"mobile", className:"h-mobile fa-light appyslim-phone-smartphone"},
          {key:"desktop", className:"h-desktop fa-light appyslim-hardware-laptop"}
        ].map(function(v, i){
          let active = "";
          if(device === v.key) {
            active = "active";
          }
          return <a data-type={v.key} key={v.key+i} onClick={() => setDevice(v.key)} className={`${v.className} ${active}`}></a>
        })
      }
      
      
    </div>
            <div className="wb-col">
                
            </div>
        </div>
        <div className={`w-100 iframe-wrapper mx-auto`} style={wrapStyle}>
            <link rel="stylesheet" type="text/css" href="/css/ui.css"/> 
            <iframe className="w-100 h-100" src={`/${props.domain}/${device}-preview/${props.subcategory}`}></iframe>
        </div>
    </div>
}